import React, {useEffect, useState} from "react";
import "./index.css";
import {Link, useHistory, useParams} from "react-router-dom";
import axios from "axios";

const NavigationBar = () => {
    const currZip = useParams().searchTerm;
    const currName = useParams().searchName;
    const [inputs, setInputs] = useState({zip:currZip, name:currName});
    const history = useHistory();
    let searchTerm = "/search/" + inputs.zip + "/" + inputs.name;
    const updateInput = (inp) => {
        setInputs({zip: inp.target.value, name:inputs.name});
        searchTerm = "/search/" + inputs.zip + "/" +  inputs.name;
    }
    const updateName = (inp) => {
        setInputs({zip: inputs.zip, name:inp.target.value});
        searchTerm = "/search/" + inputs.zip + "/" +  inputs.name;
    }

    //check if a session is going on
    const[user, setUser] = useState("")

    //using axios for easy fetching
    useEffect( () => {
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
        then(response => {
            console.log(response.data)

            if(response.data.name){
                console.log("here!!")
                setUser(response.data.name)
            }
        });
    }, []);

    const printUser = () => {
        console.log("Print is called")
        if(user)
            return user;
        else
            return "Login"
    }

    return (
        <header className="header sticky-top">
            <nav className="navbar navbar-expand-lg navbar-light bg-white py-3 shadow-sm">
                <div className="container"><Link className="navbar-brand" to="/home">
                    <strong className="h6 mb-0 font-weight-bold text-uppercase">Food Mafia</strong></Link>
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation"><span
                        className="navbar-toggler-icon"></span></button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        {/*<ul className="navbar-nav ml-auto">*/}
                        {/*    <li className="nav-item active"><a className="nav-link" href="#">Home <span*/}
                        {/*            className="sr-only">(current)</span></a></li>*/}
                        {/*         <li className="nav-item dropdown">*/}
                        {/*         <a className="nav-link dropdown-toggle" href="#dropdown-menu" id="navbarDropdown" role="button"*/}
                        {/*            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
                        {/*             Profile*/}
                        {/*         </a>*/}
                        {/*         <div className="dropdown-menu" aria-labelledby="navbarDropdown">*/}
                        {/*             <a className="dropdown-item" href="#">View Profile</a>*/}
                        {/*             <a className="dropdown-item" href="#">Log Out</a>*/}
                        {/*         </div>*/}
                        {/*     </li>*/}

                        {/*</ul>*/}
                        <div className="collapse navbar-collapse" id="navbarColor03">

                            <div  style={{float:"right"}} className="ms-5">
                                {/*<SearchBar/>*/}
                                <form className="d-flex">
                                    <input className="form-control mr-2 wd-zip"
                                           onChange={updateInput}
                                           value={inputs.zip}
                                           id="zip-id" type="search"
                                           placeholder="ZipCode"
                                           aria-label="Search"/>
                                    <input className="form-control mr-2 wd-search"
                                           onChange={updateName}
                                           value={inputs.name}
                                           id = "name"
                                           type="search" placeholder="Search"
                                           aria-label="Search"/>
                                    <div>
                                    <Link
                                        to={{
                                            pathname: searchTerm,
                                            state: { x: [inputs.zip], y:[inputs.name] }
                                        }}
                                    >
                                        {
                                            inputs.zip && inputs.name && <a style={{float: "right"}} className="wd-edit-btn me-2">
                                                <button className="btn btn-outline-info btn-light ms-2"
                                                        type="submit">Search
                                                </button>
                                            </a>
                                        }
                                    </Link>
                                    </div>
                                    <div>
                                        {
                                            (!inputs.zip || !inputs.name) && <a style={{float: "right"}} className="wd-edit-btn me-2">
                                                <button className="btn btn-outline-info btn-light ms-2"
                                                        type="submit" disabled>Search
                                                </button>
                                            </a>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>

                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item active">
                                {/*If user has logged in then display USERNAME and link it to profile screen*/}
                                {
                                    printUser() !== 'Login' && <a className="nav-link" href="/userProfile">{printUser()} <span
                                        className="sr-only">(current)</span></a>
                                }

                                {/*If user is NOT logged in then display LOGIN and link it to login screen*/}
                                {
                                    printUser() === 'Login' && <a className="nav-link" href="/login">Login <span
                                        className="sr-only">(current)</span></a>
                                }
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default NavigationBar;